import * as React from 'react';
import { ITab, TabGroup } from '@cian/components';
import { TComponentWithTabsProps } from '../../types/tabs';
import { TPikStandardTabId } from './types';
import { Standard } from '../standard/standard';
import { Children } from '../children';
import { Reliably } from '../reliably';
import { WhatIsHomeContainer } from '../../containers/WhatIsHome';
/** Раскомментируйте, чтобы добавить таб 'Трейд-ин':
 * import { TradeIn } from '../tradeIn';
 */

import * as styles from './pik-standard.css';

const TABS: ITab[] = [
  { id: 'reliably', title: 'Надёжно' },
  { id: 'standard', title: 'ПИК-Стандарт' },
  { id: 'children', title: 'ПИК — детям' },
  { id: 'home', title: 'Что такое дом?' },
  /** Раскомментируйте, чтобы добавить таб 'Трейд-ин':
   * { id: 'tradeIn', title: 'Трейд-ин' },
   */
];

const TAB_PAGES: { [key: string]: React.ReactNode } = {
  reliably: <Reliably />,
  standard: <Standard />,
  children: <Children />,
  home: <WhatIsHomeContainer />,
  /** Раскомментируйте, чтобы добавить таб 'Трейд-ин':
   * tradeIn: <TradeIn />,
   */
};

export const PikStandardComponent = (props: TComponentWithTabsProps) => {
  const { tabs, changeTabs } = props;
  const activeTab = tabs.pikstandard;
  const onTabClick = (value: TPikStandardTabId) =>
    changeTabs({
      ...tabs,
      pikstandard: value,
    });

  return (
    <div className={styles['pik-standard']}>
      <div>
        <TabGroup
          activeTab={activeTab}
          containerStyle={styles['tabs']}
          tabStyle={styles['tab']}
          activeTabStyle={styles['tab-active']}
          inactiveTabStyle={styles['tab-inactive']}
          tabs={TABS}
          onTabClick={onTabClick}
        />
      </div>

      <div className={styles['content-wrapper']}>
        <div className={styles['content']}>{TAB_PAGES[activeTab]}</div>
      </div>
    </div>
  );
};
